// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalContext_modalWrapper__CBy3x","modal":"ModalContext_modal__fx1gF"};